// Pure helpers for the Cases page: the board columns, wording for due dates and the counters.
export const COLUMNS = [
  { id: 'open', label: 'Open', color: '#fb923c' },
  { id: 'in_progress', label: 'In progress', color: '#38bdf8' },
  { id: 'blocked', label: 'Blocked', color: '#f87171' },
  { id: 'resolved', label: 'Resolved', color: '#4ade80' }
];
export const STATUS_LABEL = { open: 'Open', in_progress: 'In progress', blocked: 'Blocked', resolved: 'Resolved', closed: 'Closed' };
export const isDone = (c) => c.status === 'resolved' || c.status === 'closed';
export const isLate = (c) => !isDone(c) && c.sla_state === 'breached';

export function dueText(c, now = new Date()) {
  if (isDone(c)) return c.resolved_at ? `Done ${Math.max(0, Math.floor((now - new Date(c.resolved_at)) / 86400000))} days ago`.replace('Done 0 days ago', 'Done today').replace('Done 1 days ago', 'Done yesterday') : 'Done';
  if (!c.due_date) return 'No due date';
  const days = Math.ceil((new Date(c.due_date) - now) / 86400000);
  if (days < 0) return `${-days} day${days === -1 ? '' : 's'} late`;
  return days === 0 ? 'Due today' : `Due in ${days} day${days === 1 ? '' : 's'}`;
}

export function columns(cases) {
  const out = Object.fromEntries(COLUMNS.map((c) => [c.id, []]));
  cases.forEach((c) => out[c.status === 'closed' ? 'resolved' : c.status]?.push(c));
  return out;
}

const PRI = { critical: 0, high: 1, medium: 2, low: 3 };
// Late first, then the most urgent priority, then the soonest due.
export const urgency = (cases) => [...cases].sort((a, b) => Number(isDone(a)) - Number(isDone(b)) || Number(isLate(b)) - Number(isLate(a)) || (PRI[a.priority] ?? 4) - (PRI[b.priority] ?? 4) || String(a.due_date || '9').localeCompare(String(b.due_date || '9')));

export function counters(cases, now = new Date()) {
  const open = cases.filter((c) => !isDone(c));
  return {
    open: open.length,
    late: open.filter(isLate).length,
    inProgress: cases.filter((c) => c.status === 'in_progress').length,
    resolvedMonth: cases.filter((c) => isDone(c) && c.resolved_at && now - new Date(c.resolved_at) <= 30 * 86400000).length
  };
}

export const FILTERS = [
  { id: 'all', label: 'All', test: () => true },
  { id: 'late', label: 'Late', test: isLate },
  { id: 'blocked', label: 'Blocked', test: (c) => c.status === 'blocked' },
  { id: 'open', label: 'Not done', test: (c) => !isDone(c) }
];
export const matches = (c, q) => !q.trim() || `${c.title} ${c.target_value || ''} ${c.finding_title || ''}`.toLowerCase().includes(q.trim().toLowerCase());

// The buttons that make sense for a case in its current state.
export const NEXT = {
  open: [['in_progress', 'Start work'], ['blocked', 'Block'], ['resolved', 'Resolve']],
  in_progress: [['blocked', 'Block'], ['resolved', 'Resolve']],
  blocked: [['in_progress', 'Unblock'], ['resolved', 'Resolve']],
  resolved: [['open', 'Reopen']],
  closed: [['open', 'Reopen']]
};
